import { normalizujCislo } from './formatovanie';

function vypocitajKoeficientDtiPreZiadatela(vek, splatnostRoky) {
  const vekCislo = normalizujCislo(vek) || 0;
  const splatnostCislo = normalizujCislo(splatnostRoky) || 0;

  const trebaZnizit =
    vekCislo >= 41 && (vekCislo + splatnostCislo > 65);

  if (!trebaZnizit) return 8;

  const znizenie = Math.min((vekCislo - 40) * 0.25, 5);
  const koeficient = 8 - znizenie;

  return Math.max(koeficient, 3);
}

function vypocitajDtiPreJednehoZiadatela({
  vek,
  prijem,
  splatnostRoky,
  hypoobjem,
  ostatneobjem,
}) {
  const vekCislo = normalizujCislo(vek) || 0;
  const prijemCislo = normalizujCislo(prijem) || 0;
  const hypoobjemCislo = normalizujCislo(hypoobjem) || 0;
  const ostatneobjemCislo = normalizujCislo(ostatneobjem) || 0;

  const koeficient = vypocitajKoeficientDtiPreZiadatela(vekCislo, splatnostRoky);
  const vysledok = prijemCislo * 12 * koeficient;

  return vysledok - hypoobjemCislo - ostatneobjemCislo;
}

export function vypocitajDtiPreVsetkychZiadatelov({
  pocetziadatelov,
  splatnostRoky,
  ziadatelia,
}) {
  const pocet = Math.max(1, Math.min(4, normalizujCislo(pocetziadatelov) || 0));
  const aktivniZiadatelia = Array.isArray(ziadatelia) ? ziadatelia.slice(0, pocet) : [];

  return aktivniZiadatelia.reduce((sucet, ziadatel) => {
    return sucet + vypocitajDtiPreJednehoZiadatela({
      vek: ziadatel?.vek,
      prijem: ziadatel?.prijem,
      splatnostRoky,
      hypoobjem: ziadatel?.hypoobjem,
      ostatneobjem: ziadatel?.ostatneobjem,
    });
  }, 0);
}

// DSTI + ZAVAZKY HYPO STRESS
function vypocitajAnuitnuSplatku({ istina, mesacnaSadzba, pocetMesiacov }) {
  const P = normalizujCislo(istina) || 0;
  const r = normalizujCislo(mesacnaSadzba) || 0;
  const n = normalizujCislo(pocetMesiacov) || 0;

  if (P <= 0 || n <= 0) return 0;
  if (r === 0) return P / n;

  return P * r * Math.pow(1 + r, n) / (Math.pow(1 + r, n) - 1);
}

function vypocitajHypostressSplatkuPreJednehoZiadatela({
  hypofixacia,
  hyposplatnost,
  hyposadzba,
  hypoobjem,
}) {
  const fixaciaCislo = normalizujCislo(hypofixacia) || 0;
  const splatnostCislo = normalizujCislo(hyposplatnost) || 0;
  const sadzbaCislo = normalizujCislo(hyposadzba) || 0;
  const objemCislo = normalizujCislo(hypoobjem) || 0;

  if (objemCislo <= 0) return 0;

  const hypostressurok =
    fixaciaCislo >= 10 || splatnostCislo <= 96
      ? sadzbaCislo + 1
      : sadzbaCislo + 2;

  const finalhypostressurok = Math.min(hypostressurok, 6);
  const mesacnaSadzba = finalhypostressurok / 100 / 12;

  return vypocitajAnuitnuSplatku({
    istina: objemCislo,
    mesacnaSadzba,
    pocetMesiacov: 360,
  });
}

export function vypocitajHypostressSplatkyPreVsetkychZiadatelov({
  pocetziadatelov,
  ziadatelia,
}) {
  const pocet = Math.max(1, Math.min(4, normalizujCislo(pocetziadatelov) || 0));
  const aktivniZiadatelia = Array.isArray(ziadatelia) ? ziadatelia.slice(0, pocet) : [];

  return aktivniZiadatelia.map((ziadatel) =>
    vypocitajHypostressSplatkuPreJednehoZiadatela({
      hypofixacia: ziadatel?.hypofixacia,
      hyposplatnost: ziadatel?.hyposplatnost,
      hyposadzba: ziadatel?.hyposadzba,
      hypoobjem: ziadatel?.hypoobjem,
    })
  );
}

function vypocitajMaxHypoSplatkuPreZiadatela({
  hyposplatka,
  hypostresssplatka,
}) {
  return Math.max(
    normalizujCislo(hyposplatka) || 0,
    normalizujCislo(hypostresssplatka) || 0
  );
}

function vypocitajDstiPreJednotlivca({
  prijem,
  pocetdeti,
  maxhyposplatka,
  ostatnesplatka,
  zmJednotlivec,
  zmDieta,
}) {
  const prijemCislo = normalizujCislo(prijem) || 0;
  const detiCislo = normalizujCislo(pocetdeti) || 0;
  const maxHypoCislo = normalizujCislo(maxhyposplatka) || 0;
  const ostatneSplatkaCislo = normalizujCislo(ostatnesplatka) || 0;
  const zmJednotlivecCislo = normalizujCislo(zmJednotlivec) || 0;
  const zmDietaCislo = normalizujCislo(zmDieta) || 0;

  return (
    (prijemCislo - zmJednotlivecCislo - detiCislo * zmDietaCislo) * 0.6
    - maxHypoCislo
    - ostatneSplatkaCislo
  );
}

function vypocitajDstiPreDomacnost({
  ziadatelA,
  ziadatelB,
  hypostressA,
  hypostressB,
  zmJednotlivec,
  zmDruhyDospely,
  zmDieta,
}) {
  const prijemA = normalizujCislo(ziadatelA?.prijem) || 0;
  const prijemB = normalizujCislo(ziadatelB?.prijem) || 0;

  const detiA = normalizujCislo(ziadatelA?.pocetdeti) || 0;
  const detiB = normalizujCislo(ziadatelB?.pocetdeti) || 0;

  const ostatneA = normalizujCislo(ziadatelA?.ostatnesplatka) || 0;
  const ostatneB = normalizujCislo(ziadatelB?.ostatnesplatka) || 0;

  const maxHypoA = vypocitajMaxHypoSplatkuPreZiadatela({
    hyposplatka: ziadatelA?.hyposplatka,
    hypostresssplatka: hypostressA,
  });

  const maxHypoB = vypocitajMaxHypoSplatkuPreZiadatela({
    hyposplatka: ziadatelB?.hyposplatka,
    hypostresssplatka: hypostressB,
  });

  const zmJednotlivecCislo = normalizujCislo(zmJednotlivec) || 0;
  const zmDruhyDospelyCislo = normalizujCislo(zmDruhyDospely) || 0;
  const zmDietaCislo = normalizujCislo(zmDieta) || 0;

  return (
    (prijemA + prijemB - zmJednotlivecCislo - zmDruhyDospelyCislo - (detiA + detiB) * zmDietaCislo) * 0.6
    - (maxHypoA + maxHypoB)
    - (ostatneA + ostatneB)
  );
}

function vytvorAktivneDstiSkupiny({
  pocetziadatelov,
  ziadatelia,
  spolocnadomacnost1,
  spolocnadomacnost2,
}) {
  const pocet = Math.max(1, Math.min(4, normalizujCislo(pocetziadatelov) || 0));
  const aktivniZiadatelia = Array.isArray(ziadatelia) ? ziadatelia.slice(0, pocet) : [];
  const skupiny = [];

  const z1 = aktivniZiadatelia[0] || null;
  const z2 = aktivniZiadatelia[1] || null;
  const z3 = aktivniZiadatelia[2] || null;
  const z4 = aktivniZiadatelia[3] || null;

  if (z1) {
    if (z2 && spolocnadomacnost1) {
      skupiny.push({ typ: 'domacnost', indexy: [0, 1] });
    } else {
      skupiny.push({ typ: 'jednotlivec', indexy: [0] });
      if (z2) skupiny.push({ typ: 'jednotlivec', indexy: [1] });
    }
  }

  if (z3) {
    if (z4 && spolocnadomacnost2) {
      skupiny.push({ typ: 'domacnost', indexy: [2, 3] });
    } else {
      skupiny.push({ typ: 'jednotlivec', indexy: [2] });
      if (z4) skupiny.push({ typ: 'jednotlivec', indexy: [3] });
    }
  }

  return skupiny;
}

export function vypocitajDstiPreVsetkychZiadatelov({
  pocetziadatelov,
  ziadatelia,
  hypostressSplatky,
  spolocnadomacnost1,
  spolocnadomacnost2,
  zmJednotlivec,
  zmDruhyDospely,
  zmDieta,
}) {
  const pocet = Math.max(1, Math.min(4, normalizujCislo(pocetziadatelov) || 0));
  const aktivniZiadatelia = Array.isArray(ziadatelia) ? ziadatelia.slice(0, pocet) : [];
  const aktivneHypostressSplatky = Array.isArray(hypostressSplatky) ? hypostressSplatky.slice(0, pocet) : [];

  const skupiny = vytvorAktivneDstiSkupiny({
    pocetziadatelov: pocet,
    ziadatelia: aktivniZiadatelia,
    spolocnadomacnost1,
    spolocnadomacnost2,
  });

  return skupiny.reduce((sucet, skupina) => {
    if (skupina.typ === 'domacnost') {
      const [indexA, indexB] = skupina.indexy;

      return sucet + vypocitajDstiPreDomacnost({
        ziadatelA: aktivniZiadatelia[indexA],
        ziadatelB: aktivniZiadatelia[indexB],
        hypostressA: aktivneHypostressSplatky[indexA],
        hypostressB: aktivneHypostressSplatky[indexB],
        zmJednotlivec,
        zmDruhyDospely,
        zmDieta,
      });
    }

    const [index] = skupina.indexy;
    const ziadatel = aktivniZiadatelia[index];

    return sucet + vypocitajDstiPreJednotlivca({
      prijem: ziadatel?.prijem,
      pocetdeti: ziadatel?.pocetdeti,
      maxhyposplatka: vypocitajMaxHypoSplatkuPreZiadatela({
        hyposplatka: ziadatel?.hyposplatka,
        hypostresssplatka: aktivneHypostressSplatky[index],
      }),
      ostatnesplatka: ziadatel?.ostatnesplatka,
      zmJednotlivec,
      zmDieta,
    });
  }, 0);
}

export function vypocitajStressDtiMaxUver({
  fixacia,
  urok,
  roky,
  dstistresssplatka,
}) {
  const fixaciaCislo = normalizujCislo(fixacia) || 0;
  const urokCislo = normalizujCislo(urok) || 0;
  const rokyCislo = normalizujCislo(roky) || 0;
  const dstiCislo = normalizujCislo(dstistresssplatka) || 0;

  const stressUrok = fixaciaCislo >= 10
    ? urokCislo + 1
    : urokCislo + 2;

  const finalStressUrok = Math.min(stressUrok, 6);

  const r = finalStressUrok / 100 / 12;
  const n = Math.max(1, rokyCislo * 12);

  if (dstiCislo <= 0) return 0;

  const objem =
    r === 0
      ? dstiCislo * n
      : dstiCislo * (1 - Math.pow(1 + r, -n)) / r;

  return Math.round(objem);
}